import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest, getTeeTypeListRequest } from "../../../api/controller/EventController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const eventListState = atom({
    key: 'eventListState',
    default: [],
})

export const eventTeeTypeState = atom({
    key: 'eventTeeTypeState',
    default: {
        data: [],
        ovf: false,
    },
})

export const modalConfigDefault = { size: "md", wizard: false }

export const filtersDefault = []

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const eventDataStructureState = selector({
    key: 'eventDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Name',
                type: 'text',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Timing Cover Image',
                type: 'file',
                order: { form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Certificate Template',
                type: 'file',
                order: { form: 2.5 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
            { 
                label: 'Official Event Tee Type',
                type: 'select',
                order: { form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                list: get(eventTeeTypeState),
                getRequest: getTeeTypeListRequest,
            },
            {
                label: 'FAQ',
                type: 'wysiwyg',
                order: { form: 3.5 },
                // Answers the issue desk reads back to a runner mid-queue, so it
                // is written per event and shown on the race kits page and the
                // public volunteer page.
                create: [{ enabled: true, size: { xs: 12, md: 12 } }], update: ['same_as:create.0'], view: ['same_as:create.0'],
            },
			{
                label: 'Active',
                type: 'switch',
                order: { table: 2, form: 4 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: ['Yes', 'No'],
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
